import React, { useState } from 'react';

import { useProcurement } from './context/ProcurementContext';
import ProcurementApprovalsTab from './procurement-tab/ProcurementApprovalsTab';
import ProcurementCategoryTab from './procurement-tab/ProcurementCategoryTab';
import ProcurementDashboardTab from './procurement-tab/ProcurementDashboardTab';
import ProcurementGanttChartTab from './procurement-tab/ProcurementGanttChartTab';
import ProcurementPlanTab from './procurement-tab/ProcurementPlanTab';
import ProcurementPolicyTab from './procurement-tab/ProcurementPolicyTab';
import ProcurementPurchaseOrdersTab from './procurement-tab/ProcurementPurchaseOrdersTab';
import ProcurementPurchaseRequisitionsTab from './procurement-tab/ProcurementPurchaseRequisitionsTab';
import { PROCUREMENT_TABS, initialTabId } from './procurementTabs';

import Tabs, { RenderStrategyOnFirstVisit } from 'CommonComponents/Tabs';

import ExportIcon from 'Assets/icons/export.svg';

const ProcurementTab = () => {
    const { settings, routes } = useProcurement();

    const tabs = [
        {
            id: PROCUREMENT_TABS.DASHBOARD,
            title: $t('Dashboard'),
            content: () => <ProcurementDashboardTab />,
        },
        {
            id: PROCUREMENT_TABS.PLAN,
            title: $t('Plan'),
            content: () => <ProcurementPlanTab />,
            hidden: !settings.isProcurementPlanModuleEnabled,
        },
        {
            id: PROCUREMENT_TABS.GANTT_CHART,
            title: $t('Gantt Chart'),
            content: () => <ProcurementGanttChartTab />,
        },
        {
            id: PROCUREMENT_TABS.APPROVALS,
            title: $t('Kanban Board'),
            content: () => <ProcurementApprovalsTab />,
            hidden: !settings.isReportPurchaseOrdersModuleEnabled,
        },
        {
            id: PROCUREMENT_TABS.PURCHASE_REQUISITIONS,
            title: $t('PRs'),
            content: () => <ProcurementPurchaseRequisitionsTab />,
            hidden: !settings.isPrEnabled || !settings.isReportPurchaseOrdersModuleEnabled,
        },
        {
            id: PROCUREMENT_TABS.PURCHASE_ORDERS,
            title: $t('EAs and DCs'),
            content: () => <ProcurementPurchaseOrdersTab />,
            hidden: (!settings.isEaEnabled || !settings.isReportPurchaseOrdersModuleEnabled) && !settings.isDirectCommitEnabled,
        },
        {
            id: PROCUREMENT_TABS.POLICY,
            title: $t('Policy'),
            content: () => <ProcurementPolicyTab />,
        },
        {
            id: PROCUREMENT_TABS.CATEGORY,
            title: $t('Categories'),
            content: () => <ProcurementCategoryTab />,
        },
    ];

    const [activeTab, setActiveTab] = useState(() => initialTabId(tabs, settings.activeTabId, PROCUREMENT_TABS.DASHBOARD));

    const actions = [
        {
            for: PROCUREMENT_TABS.PURCHASE_REQUISITIONS,
            content: (
                <a className="button small primary edit-locked-budget-entity" href={routes.purchaseRequisitionsExportUrl} data-action="navigate">
                    <ExportIcon className="tw-w-3.5 tw-h-3.5" />
                    {$t('Export to file')}
                </a>
            ),
        },
        {
            for: PROCUREMENT_TABS.PURCHASE_ORDERS,
            content: (
                <a className="button small primary edit-locked-budget-entity" href={routes.purchaseOrdersExportUrl} data-action="navigate">
                    <ExportIcon className="tw-w-3.5 tw-h-3.5" />
                    {$t('Export to file')}
                </a>
            ),
        },
    ];

    return <Tabs tabs={tabs} actions={actions} activeTab={activeTab} onTabActivate={setActiveTab} renderStrategy={RenderStrategyOnFirstVisit} />;
};

export default ProcurementTab;
